// 🚀 Servicio de caché para optimizar Firebase

const CACHE_DURATION = 30 * 60 * 1000; // 30 minutos

export const cacheService = {
  // Guardar en localStorage con timestamp
  set: (key, data) => {
    try {
      const cached = {
        data,
        timestamp: Date.now()
      };
      localStorage.setItem(key, JSON.stringify(cached));
    } catch (error) {
      console.error('Error guardando en caché:', error);
    }
  },

  // Obtener del caché si no ha expirado
  get: (key) => {
    try {
      const cached = localStorage.getItem(key);
      if (!cached) return null;

      const { data, timestamp } = JSON.parse(cached);
      const now = Date.now();

      // Si ha expirado (30 min), devolver null
      if (now - timestamp > CACHE_DURATION) {
        localStorage.removeItem(key);
        return null;
      }

      return data;
    } catch (error) {
      console.error('Error leyendo caché:', error);
      return null;
    }
  },

  // Limpiar caché específico
  remove: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error limpiando caché:', error);
    }
  },

  // Limpiar todo el caché de la app
  clear: () => {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith('miEcommerce_')) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.error('Error limpiando caché:', error);
    }
  }
};

// Claves de caché estandarizadas
export const CACHE_KEYS = {
  CATEGORIES: 'miEcommerce_categories',
  BRANDS: (categoryId) => `miEcommerce_brands_${categoryId}`,
  PRODUCTS: 'miEcommerce_products'
};
